<template>
  <div>
    <nav-top />
    <div class="container-fluid">
      <div class="row flex-xl-nowrap">
        <main
          class="p-3 col-12"
          role="main"
        >
          <slot />
        </main>
      </div>
    </div>
    <hr />
    <pre class="text-right text-muted px-4"> v{{version}} </pre>
  </div>
</template>
<script>
import NavTop from '@/components/navigation/nav-top'
export default {
  name: 'layout-default',
  data() {
    return {
      version: window.config ? window.config.version : ''
    }
  },
  components: {
    NavTop
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/default.vue